import { render, staticRenderFns } from "./CartTableProductOrderItem.vue?vue&type=template&id=01fdb5fe"
import script from "./CartTableProductOrderItem.vue?vue&type=script&lang=js"
export * from "./CartTableProductOrderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports